import React, { Fragment } from "react";

import { Helmet } from "react-helmet";

import Navbar from "../components/Navbar";
import Team from "../components/Team";
import Footer from "../components/Footer";
import Founding from "../components/Founding";
import "./About.css";
import daBoys from "../public/asset0014-1400w.jpg";

const AboutUs = () => {
  return (
    <div className="about-us-container">
      <Helmet>
        <title>Coin Basis: About</title>
        <meta
          property="og:title"
          content="About-Us - Far Flung Determined Jaguar"
        />
        {/* Google Analytics */}
        <script
          async
          src="https://www.googletagmanager.com/gtag/js?id=G-1T6SHZQ9X8"
        ></script>
        <script>
          {`
            window.dataLayer = window.dataLayer || [];
            function gtag(){dataLayer.push(arguments);}
            gtag('js', new Date());
            gtag('config', 'G-1T6SHZQ9X8');
          `}
        </script>
        <script>
          {`
            (function(w,d,s,l,i){
              w[l]=w[l]||[];
              w[l].push({'gtm.start': new Date().getTime(), event:'gtm.js'});
              var f=d.getElementsByTagName(s)[0],
                  j=d.createElement(s), dl=l!='dataLayer'?'&l='+l:'';
              j.async=true;
              j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl;
              f.parentNode.insertBefore(j,f);
            })(window,document,'script','dataLayer','GTM-MTZT7D3V');
          `}
        </script>
      </Helmet>
      {/* Google Tag Manager (noscript) */}
      <noscript>
        <iframe
          title="about-analytics"
          src="https://www.googletagmanager.com/ns.html?id=GTM-MTZT7D3V"
          height="0"
          width="0"
          style={{ display: "none", visibility: "hidden" }}
        ></iframe>
      </noscript>
      {/* End Google Tag Manager (noscript) */}
      <Navbar />
      <div className="about-us-content-container">
        <div className="about-us-hero-container">
          <h1 className="hero8-text10 thq-heading-1">
            <Fragment>
              <span className="hero8-text25">About Us</span>
            </Fragment>
          </h1>
        </div>
        <div className="about-us-content">
          <Founding />
          <img
            src={daBoys}
            alt="Cryptocurrency Cost Basis Calculator"
            className="thq-img-ratio-16-9"
          />
        </div>
        <Team />
        <Footer />
      </div>
    </div>
  );
};

export default AboutUs;
